import { ComponentProps } from "react";
import * as S from "./styles";
import { textFileTruncate } from "../../../utils/textFileTruncate";
import { IArquivoDTO } from "../../../types/denuncia";

const TypeFilesAudios = ["mp3", "wav", "ogg", "mp4", "m4a"];
const TypeFilesImages = ["jpg", "jpeg", "png", "gif", "svg"];
const TypeFilesVideos = ["mp4", "mov", "avi", "wmv", "flv", "webm"];
const TypeFilesDocuments = ["doc", "docx", "pdf", "xls", "xlsx"];
interface IFileReportProps extends ComponentProps<"div"> {
  file: IArquivoDTO;
}
export const FileReport = ({ file, ...rest }: IFileReportProps) => {
  const isAudio = TypeFilesAudios.includes(file?.fileType);

  return (
    <S.FileReportStyles {...rest}>
      <img
        src={
          isAudio ? "/assets/svgs/icon-audio.svg" : "/assets/svgs/icon-file.svg"
        }
        alt="icon"
      />
      <p>{textFileTruncate({ text: file?.fileName, limit: 10 })}</p>
    </S.FileReportStyles>
  );
};
